import axios from "axios";

export const transactionEndpoints = (builder) => ({
    getTransactions: builder.query({
        query: (userGroup) => ({ url: `/transactions?userGroup=${userGroup}`, method: 'get' }),
        providesTags: ['Transactions'],
    }),
    getTransactionSummary: builder.query({
        query: ({ accountId }) => ({ url: `/transactions/summary/${encodeURIComponent(accountId)}`, method: 'get' }),
        providesTags: ['Transactions'],
    }),
    downloadTransactionsReport: builder.mutation({
        query: ({ userId, userGroup, refId, liveData, partner, startDate, endDate, status, format, type }) => ({
            url: `/transactions/report/${format}?userGroup=${userGroup || ""}`
                + `&userId=${userId || ""}`
                + `&refId=${refId || ""}`
                + `&liveData=${liveData || ""}`
                + `&partner=${partner || ""}`
                + `&startDate=${startDate || ""}`
                + `&endDate=${endDate || ""}`
                + `&status=${status || ""}`
                + `&type=${type || ""}`,
            method: 'post'
        }),
    }),
    submitAccountsHistoryExport: builder.mutation({
        query: (filters = {}) => {
            const queryParams = new URLSearchParams();

            Object.entries(filters).forEach(([key, value]) => {
                if (value === undefined || value === null || value === "") {
                    return;
                }

                queryParams.append(key, value);
            });

            const queryString = queryParams.toString();

            return {
                url: `/accounts/admin/history-filter/export${queryString ? `?${queryString}` : ""}`,
                method: 'post',
                body: filters,
            };
        },
    }),
    pollAccountsHistoryExport: builder.mutation({
        async queryFn({ jobId, page = 1, limit = 10000 } = {}) {
            try {
                const response = await axios.get(`/accounts/admin/history-filter/export/${jobId}`, {
                    params: { page, limit },
                    validateStatus: () => true,
                });

                if (response.status === 200 || response.status === 202) {
                    return {
                        data: {
                            status: response.status,
                            payload: response.data,
                        },
                    };
                }

                return {
                    error: {
                        status: response.status,
                        data: response.data?.error || response.statusText || "Transactions export failed",
                    },
                };
            } catch (error) {
                return {
                    error: {
                        status: error?.response?.status,
                        data: error?.response?.data?.error || error?.message || "Transactions export failed",
                    },
                };
            }
        },
    }),
    approveTransaction: builder.mutation({
        query: (data) => ({ url: `/transactions/approve`, method: 'post', body: data }),
        providesTags: ['Transactions'],
    }),
    declineTransaction: builder.mutation({
        query: (data) => ({ url: `/transactions/decline`, method: 'put', body: data }),
        providesTags: ['Transactions'],
    }),
    addTransaction: builder.mutation({
        query: body => ({ url: `/transactions/add-transaction`, method: 'post', body }),
        providesTags: ['Transactions'],
    }),
})
